import { defineMessages } from 'react-intl';

export default defineMessages({
  minusButton: {
    id: 'ariaLabel.minusButton',
    defaultMessage: 'Reduce quantity',
  },
  plusButton: {
    id: 'ariaLabel.plusButton',
    defaultMessage: 'Increase quantity',
  },
});
